<template>
    <div class="inner-container">
        <div class="section-title budget"><i class="icon icon-calculator-coins"></i><span>{{ getCommonText('budget') }}</span></div>
        <div class="section-subtitle"><i class="icon icon-grid"></i><span>{{ $t("app.links.budget_requests") }}<budget-forms-list :curFormSelect="'/form01-123'"/></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadDeltaRep="downloadDeltaRep"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
            ></forms-download-reprt>
        </div>
        <div class="filter-container">
            <div class="left-content">
                <budget-header v-show="categoryMode" ref="budgetHeader" :form="form" @chgData="changeHeader" :yearReq="true" :openDisabled="openDisabled" @setProgress="setProgress"></budget-header>
                <p v-if="!categoryMode" class="title">{{ getCommonText('decoding') }}. {{ caterogyName }}</p>
            </div>
            <div class="right-content">
                <c-budget-forms-data-transfer
                    v-if="categoryMode && !isGkkpMode && !(progress < 100) && variantAttribute"
                    :header="header"
                    :lng="lng"
                    :getDataTransferText="getDataTransferText"
                    :getErrText="getErrText"
                    :makeToast="makeToast"
                    @reloadTable="loadDatas"
                />
                <div class="filter-actions filter-actions-flex">
                    <template v-if="categoryMode">
                        <c-budget-forms-copy-data
                            v-if="!(progress < 100) && variantAttribute && (header.year < header.cur_year + 2)"
                            :budgetForm="budgetForm"
                            :header="header"
                            :isLoad="isLoad"
                            @keyPress="keyPress"
                        />
                        <b-button variant="primary" @click="addItem" v-if="variantAttribute" :disabled="isLoad"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</b-button>
                    </template>
                    <template v-else>
                        <b-button variant="light" @click="resetModal">
                           <i class="icon icon-keyboard icon-rotate-180"></i> {{ getCommonText('back_to_list') }}
                        </b-button>
                        <b-button :style="{ 'minWidth': '110px' }" v-if="variantAttribute" variant="primary" @click="$refs.formTemplate.addItem()">
                            <i class="icon icon-plus-circle"></i>{{ getCommonText('add') }}
                        </b-button>
                        <b-button
                            :style="{ 'minWidth': '110px' }" 
                            :disabled="!dataChanged || goodsAreSaving"
                            variant="success"
                            @click="prepareForSave">
                            {{ getCommonText('save') }}
                        </b-button>
                    </template>
                </div>
            </div>
        </div>

        <breadcrumbs-filter v-show="categoryMode" :header="breadcrumbsHeader" :data-type-filter="dataTypeFilter"
                            :variant-name="variantName" @openFilterByRef="openFilterByRef"/>
        <b-progress
                variant="success"
                v-show="!enteredFromOtherMode && progress < 100 && progress > 0"
                height="10px"
                :value="progress"
                striped
                animated
        ></b-progress>

        <filter-empty-placeholder v-if="enteredFromOtherMode" />
        <template v-else>
        <div v-show="categoryMode" class="table-container">
            <b-overlay :show="mainTableOverlay" rounded="sm">
            <b-table
                :fields="tableFields"
                :items="budgetForm"
                responsive="true"
                bordered
                head-variant="light"
                sticky-header="true"
                no-border-collapse
            >
                <template #top-row="data">
                    <td></td>
                    <td class="td-numbering"></td>
                    <td class="td-numbering text-center table-success">1</td>
                    <td class="td-numbering text-center table-danger">2</td>
                    <td class="td-numbering text-center table-info">3</td>
                    <td class="td-numbering text-center table-primary">4</td>
                    <td class="td-numbering text-center table-warning">5</td>
                    <td class="td-numbering text-center table-success">6</td>
                    <td class="td-numbering"></td>
                </template>
                <template #head(selection)>
                    <div class="text-center">
                        <b-form-checkbox
                            v-model="selectAll"
                            @change="e => setIsAllDelete(e)"
                            :value="true"
                            :unchecked-value="false" />
                    </div>
                </template>
                <template #head(more)>
                    <div class="text-center">
                        <i
                            :title="getCommonText('del_selected')"
                            class="icon icon-close table-all-remove"
                            @click="deleteItem(`${selectAll ? getCommonText('all_cats') : getCommonText('selected_cats')}`)"/>
                    </div>
                </template>
                <template #cell(selection)="data">
                    <b-form-checkbox
                        v-model="data.item.itemToDelete"
                        @input="e => { if (!e) selectAll = false; }"
                        :value="true"
                        :unchecked-value="false" />
                </template>
                <template #cell(action)="data">
                    <button
                        class="table-plus"
                        v-b-modal.goods-modal @click="setCurrCatName(data.item)"
                        :disabled="data.item.checkForDuplicates || !data.item.group || data.item.nameUpdating">
                        <i class="icon icon-plus-circle"/>
                    </button>
                </template>
                <template #cell(group)="data">
                    <div
                        class="column-width-100"
                        :class="{ 'error': data.item.checkForDuplicates }">
                        <multiselect
                                v-if="variantAttribute"
                                v-model="data.item.group_obj"
                                :disabled="isEditForbidden(data.item)"
                                label="text"
                                :placeholder="getFormText('select_cat')"
                                :options="dict"
                                :searchable="true"
                                :allow-empty="false"
                                :show-labels="false"
                                @input="() => { onChangeName(data.item); data.item.rowToSave = true; saveCats(data.item); }"
                            >
                        </multiselect>
                        <div v-else>{{ data.item.group_obj.value[`name_${lng}`] }}</div>
                        <template v-if="data.item.checkForDuplicates">
                            <i class="icon icon-danger"></i>
                            <div class="pop-up">
                                <p class="red-text">{{ getCommonText("not_valid") }}</p>
                                <p>{{ getCommonText("exist") }}</p>
                            </div>
                        </template>
                    </div>
                </template>
                <template #cell(amount)="data">
                    <div class="text-right">{{ $n(data.value) }}</div>
                </template>
                <template #cell(payment)="data">
                    <div class="text-right">{{ $n(data.value) }}</div>
                </template>
                <template #cell(months)="data">
                    <b-form-input v-if="variantAttribute"
                                  class="text-right"
                                  :disabled="!data.item.group_obj || isEditForbidden(data.item)"
                                  v-model="data.item.months"
                                  @update="data.item.rowToSave = true"
                                  @change="onChangeName(data.item)"
                                  @keyup="checkNumber($event, 1, 12)"
                                  @keyup.enter.exact="keyup13"
                                  @keypress="keyPress($event, '^[0-9]+$')"
                                  @blur="inputFixed(data.item, 'total', data.item.months, 3)">
                    </b-form-input>
                    <div v-else class="text-right">{{ data.value }}</div>
                </template>
                <template #cell(total)="data">
                    <div class="text-right">{{ $n(data.value) }}</div>
                </template>
                <template #cell(files)="data">
                    <span
                        class="blue pointer underline"
                        @click="onAllFilesClick({ ...data.item, name_ru: data.item.group_obj.text})"
                    >({{data.item.files ? data.item.files.length : 0}})</span>
                </template>
                <template #cell(more)="data">
                    <i class="icon icon-clear table-remove"  v-if="variantAttribute" :disabled="deletingCat" @click="deleteItem(`${getCommonText('curr_cat')}`, {...data.item, good_type: data.item}, data.index, true)"></i>
                </template>

                <template #bottom-row="data">
                    <td class="text-right" colspan="6">{{ getCommonText('total') }}</td>
                    <td class="text-right">{{ $n(total) }}</td>
                    <td colspan="2"></td>
                </template>
            </b-table>
            </b-overlay>
            <div class="table-add" v-if="variantAttribute" :disabled="isLoad">
                <span @click="addItem"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</span>
            </div>
        </div>
        <template v-if="!categoryMode">
            <b-overlay :show="templateTableOverlay" rounded="sm">
                <form-03149-template1
                    ref="formTemplate"
                        :formCode="form.code"
                        :goodsData="goodsData"
                        :initialGoodsData="initialGoodsData"
                        :ensTruDict="ensTruDict"
                        :variantAttribute="variantAttribute"
                        :currCategory="currCategory"
                        :lang="lang"
                        :ifAllFieldsFilled="ifAllFieldsFilled"
                        :deleteGood="deleteGood"
                        :getUnitName="getUnitName"
                        :ensTruNamePrt="ensTruNamePrt"
                        :ensTruName="ensTruName"
                        :currUnits="currUnits"
                        :descIsLoading="descIsLoading"
                        :parNameLoading="parNameLoading"
                        :allFiles="allFiles"
                        @setTotals="setTotals"
                        @updateDatas="updateDatas"
                        @save="save"
                        @onDataChanged="onDataChanged"
                        @searchName="searchName"
                        @setIsAllDelete="setIsAllDelete"
                        @deleteSeveralGoods="deleteSeveralGoods"
                        @doublesValidationDecodes="doublesValidationDecodes"
                        :triggDownloadFile="triggDownloadFile"
                        :triggDownloadAllFiles="triggDownloadAllFiles"
                        :showFileUploadModal="showFileUploadModal"
                        :getEnstruByName="getEnstruByName"
                        :loadCurUnits="loadCurUnits"
                        :goodsAreSaving="goodsAreSaving"
                        :isDoubleDecodeExist="isDoubleDecodeExist"
                ></form-03149-template1>
                <div class="table-add" v-if="variantAttribute" >
                    <span @click="$refs.formTemplate.addItem()"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</span>
                </div>
            </b-overlay>
        </template>
        <files-updown v-if="isFilterReady"
                      ref="filesUpdown"
            v-show="categoryMode"
            :header="header"
            :variant-attribute="variantAttribute"
            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
            :load="load"
            :showDeleteLinks="variantAttribute"
            :showDeleteAll="true"
            @getFiles="getFiles"
            @fillFilesList="fillFilesList"
            @restetFilesList="restetFilesList"
            @delelteAttachedFile="delelteAttachedFile"
            @onFilePreview="onFilePreview"
        ></files-updown>
        <modal-all-files-management
            ref="modalAllFilesManagement"
            :allFiles="allFiles"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
            >
        </modal-all-files-management>
        </template>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import BudgetHeader from '@/modules/budget-request/budget-header-new.vue';
import FilesUpdown from '@/modules/budget-request/FilesUpdown';
import BudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import BreadcrumbsFilter from '@/modules/budget-request/components/breadcrumbs-filter.vue';
import FormsHandlerMixin from "./mixins/forms-handler-mixin";
import Form03149Template1 from "./components/budget-forms-template1.vue";
import ModalAllFilesManagement from './components/modal-all-files-management.vue';
import CBudgetFormsCopyData from './components/budget-forms-copy-data.vue';
import FormsDownloadReprt from "./components/forms-download-reprt.vue";
import CBudgetFormsDataTransfer from './components/budget-forms-data-transfer.vue';
import FilterEmptyPlaceholder from '@/modules/budget-request/components/filter-empty-placeholder.vue';

export default {
    name: 'Form01_153',
    components: {
        BudgetHeader,
        FilesUpdown,
        BudgetFormsList,
        FormsDownloadReprt,
        BreadcrumbsFilter,
        Form03149Template1,
        ModalAllFilesManagement,
        CBudgetFormsCopyData,
        CBudgetFormsDataTransfer,
        FilterEmptyPlaceholder
    },
    mixins: [FormsHandlerMixin],
    data() {
        return {
            form: {
                code: '01-153',
                name_kk: 'Көлiк қызметтерiне ақы төлеу бойынша шығыстарды есептеу',
                name_ru: 'Расчет расходов по оплате транспортных услуг'
            },
            dataTypeFilter: null,
            variantAttribute: null,
            variantName: null,
            budgetForm: [],
            header: null,
            dict: [],
            files: null,
            load: false,
            openDisabled: false,
            isLoad: false,
            savingTriesCounter: 0
        };
    },
    mounted() {
        this.progress = 15;
    },
    watch: {
        lang: {
            handler() {
                this.sortDict();
            }
        }
    },
    methods: {
        itemUpdate(item) {
            this.$set(item, 'amount', 0);
            this.$set(item, 'payment', 0);
            this.$set(item, 'total', 0);
            this.$set(item, 'months', 1);
            this.$set(item, 'newCat', true);
            this.$set(item, 'nameUpdating', false);
            this.$set(item, 'category_id', this.uuidv4());
            this.$set(item, 'code', item.category_id);
            this.$set(item, 'checkForDuplicates', false);
            this.$set(item, 'itemToDelete', false);
        },

        changeGroup(item) {
            this.$set(item, 'group', item.group_obj.value.code);
        },

        onChangeName(value) {
            if (!value.group_obj) return;
            this.changeGroup(value);
            this.checkForDuplicates();
        },

        afterDeleted() {
            this.checkForDuplicates();
        },

        checkForDuplicates() {
            const existingItems = {};
            for (const [idx, item] of this.budgetForm.entries()) {
                const curGroupMonth = `${item.group}_${item.months}`;
                if (existingItems.hasOwnProperty(curGroupMonth)) {
                    this.budgetForm[existingItems[curGroupMonth]].checkForDuplicates = true;
                    item.checkForDuplicates = true;
                    this.areDoublesFound = true;
                    break;
                } else {
                    item.checkForDuplicates = false;
                    existingItems[curGroupMonth] = idx
                }
                this.areDoublesFound = false;
            };
        },

        fillDataForSave(item, row) {
            this.$set(item, 'category_id', this.currCategory.category_id);
            this.$set(item, 'amount', parseFloat(row.amount));
            this.$set(item, 'payment', parseFloat(row.price));
        }, // заполнение полей при подготовке к сохранению товаров

        async delete(item, showMsg = true) {
            this.$set(item, 'form', this.form.code);
            this.$set(item, 'mode', this.header.mode);
            try {
                const response = await fetch('/api-py/delete-budget-request-form/', {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(item)
                });
                const result = await response.json();
                if (response.status === 200) {
                    if (showMsg) {
                        await this.updateDatas(true);
                        this.makeToast('success', this.getErrText('msg'), this.getErrText('one_deleted'));
                    }
                }
            } catch {
                this.makeToast('danger', this.getErrText('warning'), this.getErrText('on_del'));
            }
        }, // удаление данных

        setTotals(val) {
            const amount = this.safeDecimal(val.amount);
            const total = amount.mul(this.safeDecimal(val.price)).toNumber();
            this.$set(val, 'total', total);
        },

        inputFixed(item, field, value, digit) {
            if (!value) value = 1;
            const total = this.calcCatTotal(item.amount, item.paymentNotRounded, item.months);
            // const total = parseInt(item.amount) * parseFloat(item.payment) * parseInt(item.months) / 1000;
            this.$set(item, field, this.roundNumber(total, digit));
            if (!item.group) return;
            this.resetSavingAtemptsLimit();
            this.saveCats(item);
        }, // форматирует введенное значение до digit цифр после запятой

        getFiles(data) {
            this.files = data;
        },

        getItem(code, list) {
            for (const item of list) {
                if (parseInt(item.value.code) === parseInt(code)) {
                    return item;
                }
            }
            return null;
        }, // возвращает объект по коду с заданного списка

        getRowKey(row, keys) {
            let key = '';
            for (const k of keys) {
                key = key + this.padLeadingZeros(row[k], 3) + '.';
            }
            return key;
        }, // преобразует значения выбранных полей в код

        keyPress: function (event, pattern) {
            const regex = new RegExp(pattern);
            const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, // вводит по заданному паттерну

        keyup13: function (event) {
            event.preventDefault();
            // Isolate the node that we're after
            const currentNode = event.target;
            // find all tab-able elements
            const allElements = document.querySelectorAll('input'); // area, object, select, [contenteditable]
            // Find the current tab index.
            const currentIndex = [...allElements].findIndex(el => currentNode.isEqualNode(el));
            // select/focus the following element
            const targetIndex = (currentIndex + 1) % allElements.length;
            if (targetIndex < allElements.length) {
                allElements[targetIndex].select();
            }
        }, // enter работает как tab

        getFormCode() {
            // при необходимости заменить в родительском компоненте. Напр. Form01_142.vue
            return `${this.form.code}-decode`;
        },
        
        async loadCategoryData() {
            this.load = true;
            await this.loadDatas();
            if (!this.budgetForm.length) return;
            const catIdList = [];
            this.budgetForm.forEach(item => catIdList.push(item.category_id))
            this.$set(this.header, 'cat_id_list', catIdList)
            try {
                const response = await fetch('/api-py/get-budget-request-form-cat/' + JSON.stringify(this.header));
                    if (response.status === 200) {
                        const values = await response.json();
                        this.budgetForm.forEach(item => {
                            const currVal = values.find(val => val.category_id === item.category_id);
                            if (currVal) {
                                const amount = this.safeDecimal(currVal.sum_amount).toDecimalPlaces(2);
                                const payment = this.safeDecimal(currVal.avg_price).toDecimalPlaces(2);
                                const months = this.safeDecimal(item.months).toDecimalPlaces(0);
                                const total = amount.mul(this.safeDecimal(currVal.avg_price)).mul(months).div(1000).toDecimalPlaces(3).toNumber();
                                this.$set(item, 'total', total);
                                this.$set(item, 'paymentNotRounded', currVal.avg_price);
                                if (this.variantAttribute && (item.amount !== currVal.sum_amount || item.payment !== this.roundNumber(currVal.avg_price, 2))) {
                                    this.$set(item, 'amount', amount.toNumber());
                                    this.$set(item, 'payment', payment.toNumber());
                                    this.$set(item, 'rowToSave', true);
                                    
                                    if (this.variantAttribute && this.savingTriesCounter <= 10) {
                                        ++this.savingTriesCounter;
                                        this.saveCats(item, true);
                                    }
                                }
                                this.$set(item, 'files', this.getUnicFilesArr(currVal));
                            } else {
                                if (this.variantAttribute && (item.amount !== 0 || item.payment !== 0)) {
                                    this.$set(item, 'amount', 0);
                                    this.$set(item, 'payment', 0);
                                    this.$set(item, 'rowToSave', true);
                                    this.$set(item, 'total', 0);
                                    if (this.variantAttribute && this.savingTriesCounter <= 10) {
                                        ++this.savingTriesCounter;
                                        this.saveCats(item, true);
                                    }
                                }
                                this.$set(item, 'total', 0);
                                this.$set(item, 'files', []);
                            }
                        }); //привеодим данные в таблице категорий в соответствие с расшифровками
                    }
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadCategoryData()`, error.toString());
            }
            this.load = false;
        },

        async loadDatas() {
            this.load = true;
            let values = [];
            try {
                const response = await fetch('/api-py/get-budget-request-form/' + JSON.stringify(this.header));
                values = await response.json();
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDatas()`, error.toString());
            }

            const newBudgetDatas = [];
            await values.forEach(val => {
                const item = {
                    id: val.id,
                    group: val.group,
                    group_obj: this.getItem(val.group, this.dict),
                    code: val.category_id,
                    category_id: val.category_id,
                    amount: val.amount,
                    payment: val.payment,
                    months: val.months,
                    total: 0,
                    rowToSave: false,
                    newCat: false,
                    oldName: val.group,
                    nameUpdating: false,
                    itemToDelete: false,
                    checkForDuplicates: false
                };
                newBudgetDatas.push(item);
            });
            this.budgetForm = newBudgetDatas;
            this.budgetForm.sort((a, b) => a.id - b.id);
            this.checkForDuplicates();
            this.load = false;
        },

        prepareData(val) {
            this.$set(val, 'price', val.payment)
        },

        async loadDict() {
            this.dict.splice(0);
            try {
                const response = await fetch('/api-py/dictionary/transport_groups/');
                const items = await response.json();

                for (const row of items) {
                    const el = {};
                    this.$set(el, 'value', row);
                    Object.defineProperty(el, 'text', {
                        get: () => {
                            if (this.lng) return row[`name_${this.lng}`];
                            return row.name_ru;
                        }
                    });
                    this.dict.push(el);
                }
                this.sortDict();
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDict()`, error.toString());
            }
        },

        sortDict() {
            this.dict.sort((a, b) => a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1);
        },

        noAbc: function (event) {
            const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
            const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, // вводит только цифры

        padLeadingZeros(num, size) {
            let s = String(num);
            while (s.length < size) { s = '0' + s; }
            return s;
        }, // добавляет 0-ли перед num до size-значного размера

        rowClass(item, type) {
            if (!item || type !== 'row') {
                return;
            }
            if (!item.visible) {
                return 'is-hidden';
            }
        }, // задает класс 'is-hidden' заданной строке

        getCodeFieldName() {
            return 'category_id';
        },

        updateTotalBeforeSave(isCatDeleting = false, prop = 'totalAll') {
            const currTotal = isCatDeleting ? {totalAmount: 0, totalAvgPrice: 0} : this.$refs.formTemplate.getTotal01153()[prop];
            if (currTotal.totalAmount >= 0 && currTotal.totalAvgPrice >= 0) {
                for (const cat of this.budgetForm) {
                    if (cat[this.getCodeFieldName()] === this.currCategory.code) {
                        let total = 0;
                        if (isCatDeleting) {
                            this.$set(cat, 'amount', currTotal.totalAmount);
                            this.$set(cat, 'payment', currTotal.totalAvgPrice);
                            total = this.calcCatTotal(cat.amount, cat.paymentNotRounded, cat.months);
                        } else total = this.newTotal(cat);
                        
                        this.$set(cat, 'total', total);
                    }
                }
            }
            this.updtHeader();
        },

        // пересчет тотала при удалении нескольких записей
        calcGoodsTotalBeforeDel() {
            return this.budgetForm.length
                ? this.budgetForm.reduce((acc, curr) => {
                                if (this.currCategory && curr.category_id === this.currCategory.code) {
                                    const newTotalRounded = this.newTotal(curr);
                                    return acc + newTotalRounded

                                } else return acc + curr.total;
                                }, 0)
                : 0;
        },

        newTotal(curr) {
            const goodsTotals = this.safeDecimal(this.$refs.formTemplate.getTotal()['totalAll']);
            const goodsAmount = this.safeDecimal(this.$refs.formTemplate.getTotal01153()['totalAll']['totalAmount']);
            let avgSalary = 0;
            if (goodsAmount > 0) {
                avgSalary = goodsTotals.div(goodsAmount).toDecimalPlaces(2).toNumber();
            }
            const newTotal = this.calcCatTotal(goodsAmount, avgSalary, curr.months);
            return newTotal;
        },

        isCatShouldBeSaved(row, bf) {
            return bf.id !== row.id && !bf.checkForDuplicates && bf.group !== bf.oldName;
        },

        calcCatTotal(amount, paymentNotRounded, months) {
            const amnt = this.safeDecimal(amount).toDecimalPlaces(2);
            const pmnt = this.safeDecimal(paymentNotRounded);
            const mnth = this.safeDecimal(months).toDecimalPlaces(0);

            return amnt.mul(pmnt).mul(mnth).div(1000).toDecimalPlaces(3).toNumber();
        },
    },
    computed: {
        total() {
            let sum = 0;
            for (const row of this.budgetForm) {
                sum += parseFloat(row.total);
            }
            return Math.ceil(sum);
        },
        caterogyName() {
            const localNameField = this.$i18n.locale === 'kk' ? 'name_kk' : 'name_ru';
            const localeMonths = this.$i18n.locale === 'kk' ? 'ай' : 'мес.';
            return `${this.currCategory.group_obj.value[localNameField]} (${this.currCategory.months} ${localeMonths})`
        },

        getFormText() {
            return this.setFormText('form_01_153.');
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: 'selection',
                        label: ' '
                    },
                    {
                        key: 'action',
                        label: ' '
                    },
                    {
                        key: 'group',
                        label: this.getFormText('transport_type')
                    },
                    {
                        key: 'amount',
                        label: this.getFormText('count')
                    },
                    {
                        key: 'payment',
                        label: this.getFormText('monthly_expenses')
                    },
                    {
                        key: 'months',
                        label: this.getFormText('month_count')
                    },
                    {
                        key: 'total',
                        label: this.getFormText('annual_expenses')
                    },
                    {
                        key: 'files',
                        label: this.getCommonText('files')
                    },
                    {
                        key: 'more',
                        label: ''
                    }
                ];
            };
            return [];
        },
    }
};
</script>
<style scoped>
.error .multiselect__tags {
    padding-left: 25px;
}
.filter-actions-flex {
    display: flex;
}
.table-plus {
    border: none;
}
</style>